import queryString from 'querystring';
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('TAG_MODERATIONS_QUALIFICATION_MEDIAS').plugin(axiosPlugin, {template: "array"});
let fetchAction = redux.fetchActionGet();


export const TYPES = redux.types;

export const fetchQualificationMedias = (query, more = false) => fetchAction(`/tag-moderations/qualifications/?${queryString.stringify(query)}`,null,{more});
export const resetQualificationMedias = () => redux.actions.reset();

export const qualificationMedias = redux.reducer();
